import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PrintStore } from '@app/@shared';
import { DetailSignatureDigitalDialog } from '@app/@shared/dialogs/detail-signatureDigital/detail-signature-digital.component';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { TranslateService } from '@ngx-translate/core';
import FileSaver from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { AdminStore } from '../admin-service/admin-service.store';
import { DigitalSignatureResponseDTO, DigitalSignReportVO } from '../model/users-model';

@Component({
  selector: 'app-digitalSignature',
  templateUrl: './digitalSignature.component.html',
  styleUrls: ['./digitalSignature.component.scss'],
})
export class DigitalSignatureComponent implements OnInit {
  public digitalSignatureForm: FormGroup;
  sendButtonRequestDisabled: boolean = true;
  hasCalledOnce: boolean = false;

  //Order of the headers' labels displayed in the table, using id
  displayedColumns = [
    'request',
    'version',
    'nif',
    'logaltyDocResult',
    'statusFinalLogalty',
    'webDocResult',
    'statusFinalWeb',
    'statusWebPetition',
    'receptorHost',
    'statusfinalHost',
    'statusHostPetition',
    'action',
    'more',
  ];

  public head = [
    [
      'Número solicitud',
      'Versión',
      'NIF/NIE',
      'Doc result Logalty',
      'Est. final Logalty',
      'Doc result Web',
      'Est. final Web',
      'Est. petición Web',
      'Receptor Host',
      'Est. final Host',
      'Est. petición Host',
    ],
  ];

  columnsToDisplay: any[] = this.displayedColumns.slice();

  dataSource = new MatTableDataSource<DigitalSignReportVO>();

  constructor(
    private formBuilder: FormBuilder,
    public adminStore: AdminStore,
    private translate: TranslateService,
    private excelService: ExcelService,
    private dialog: MatDialog,
    private printStore: PrintStore
  ) {}

  ngOnInit(): void {
    this.digitalSignatureForm = this.formBuilder.group({
      numOperation: [''],
      nif: [''],
      guid: [''],
      // numContract: [''],
      // Contractversion: [''],
      // petitionStatus: [''],
      // fileStatus: [''],
      // cancellationOption: [''],
      // dateInit: [''],
      // dateEnd: [''],
      // dateUpdate: [''],
      // phone: ['', ],
      // name: ['', ],
      // fisrtname: ['', ],
      // lastname: ['', ],
      // email: ['', ],
      //reasonCancellation: ['', ],
    });
  }

  ngAfterViewInit(): void {
    this.digitalSignatureForm.valueChanges.subscribe((formValues: any) => {
      for (var key in formValues) {
        if (formValues.hasOwnProperty(key)) {
          if (
            key !== 'numContract' &&
            key !== 'Contractversion' &&
            key !== 'petitionStatus' &&
            key !== 'cancellationOption' &&
            key !== 'dateInit' &&
            key !== 'dateEnd' &&
            formValues[key] !== '' &&
            formValues[key] !== null
          ) {
            this.sendButtonRequestDisabled = false;
            break;
          } else {
            this.sendButtonRequestDisabled = true;
          }
        }
      }
    });
  }

  viewRequest(data: DigitalSignReportVO) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = '800px';
    dialogConfig.data = { data: data };
    dialogConfig.data = { data: data };
    this.dialog.open(DetailSignatureDigitalDialog, dialogConfig);
  }

  viewResults() {
    this.dataSource.data = [];
    this.adminStore
      .resultsSignatureReport(this.digitalSignatureForm)
      .then(
        (data: DigitalSignatureResponseDTO) => {
          this.dataSource.data = data.digitalSignReportVO;
          console.log(this.dataSource.data);
        },
        (error) => {
          console.error(error);
        }
      )
      .finally(() => (this.hasCalledOnce = true));
  }

  cancelOperationSignature(data: DigitalSignReportVO) {
    let RequestCancelDTO = {
      guid: data.dataWeb.guid,
      externalId: data.dataWeb.externalId,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    dialogConfig.data = {
      title: this.translate.instant('digitalSignature.title'),
      text: this.translate.instant('cancelDigitalSignatureDialog.text'),
      icon: 'icon-ic_warning',
      buttonCancel: true,
    };

    const dialogBindingOffer = this.dialog.open(ResponseDialogComponent, dialogConfig);
    dialogBindingOffer.afterClosed().subscribe((accept: boolean) => {
      if (accept !== undefined) {
        if (accept) {
          if (data.cancelOperation === 'S' && data.dataWeb.ine === 'S') {
            this.adminStore.cancelSignatureINE(RequestCancelDTO).then(
              (data: any) => {
                this.viewResults();
              },
              (error) => {
                this.showDialogError(error);
              }
            );
          } else if (data.cancelOperation === 'S' && data.dataWeb.ine === 'N') {
            this.adminStore.cancelSignatureContract(RequestCancelDTO).then(
              (data: any) => {
                this.viewResults();
              },
              (error) => {
                this.showDialogError(error);
              }
            );
          }
        }
      }
    });
  }

  printCertificate(dataOperation: DigitalSignReportVO) {
    let RequestCertificateDTO = {
      guid: dataOperation.dataWeb.guid,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    dialogConfig.data = {
      title: this.translate.instant('digitalSignature.title'),
      text: this.translate.instant('printDigitalSignatureDialog.text'),
      icon: 'icon-ic_warning',
      buttonCancel: true,
    };

    const dialogBindingOffer = this.dialog.open(ResponseDialogComponent, dialogConfig);
    dialogBindingOffer.afterClosed().subscribe((accept: boolean) => {
      if (accept !== undefined) {
        if (accept) {
          this.adminStore.printCertificate(RequestCertificateDTO).then(
            (data: any) => {
              //TODO: ver como pasar el idioma
              this.printStore.openPDFOnSuccess(data, dataOperation.dataWeb.strNumSol, 'ES', dataOperation.dataWeb.guid);
            },
            (error) => {
              this.showDialogError(error);
            }
          );
        }
      }
    });
  }

  createExcel() {
    let dataForExcel: any[] = [];
    let rowNew: any;

    this.dataSource.data.forEach((row: DigitalSignReportVO) => {
      for (var clave in row) {
        if (row.hasOwnProperty(clave) && row[clave] === null) {
          row[clave] = ' ';
        }
      }

      rowNew = {
        request: row.dataWeb.strNumSol ? row.dataWeb.strNumSol : ' ',
        version: row.dataWeb.versionSignature ? row.dataWeb.versionSignature : ' ',
        nif: row.dataWeb.legalIdentity_id ? row.dataWeb.legalIdentity_id : ' ',
        logaltyDocResult: row.dataLogalty.document_result ? row.dataLogalty.document_result : ' ',
        statusFinalLogalty: row.dataLogalty.final_state ? row.dataLogalty.final_state : ' ',
        webDocResult: row.dataWeb.document_result ? row.dataWeb.document_result : ' ',
        statusFinalWeb: row.dataWeb.final_state ? row.dataWeb.final_state : ' ',
        statusWebPetition: row.dataWeb.strEstPeticion ? row.dataWeb.strEstPeticion : ' ',
        receptorHost: row.dataHost?.legalIdentity_id ? row.dataHost.legalIdentity_id : ' ',
        statusfinalHost: row.dataHost?.final_state ? row.dataHost.final_state : ' ',
        statusHostPetition: row.dataHost?.strEstPeticion ? row.dataHost.strEstPeticion : ' ',
      };

      const { ...data } = rowNew;

      const dataExcelOrder = JSON.stringify(data, [
        'request',
        'version',
        'nif',
        'logaltyDocResult',
        'statusFinalLogalty',
        'webDocResult',
        'statusFinalWeb',
        'statusWebPetition',
        'receptorHost',
        'statusfinalHost',
        'statusHostPetition',
      ]);

      const ObjectDataExcel = JSON.parse(dataExcelOrder);
      console.log(ObjectDataExcel);
      dataForExcel.push(Object.values(ObjectDataExcel));
    });

    const excelData = { headers: this.head[0], data: dataForExcel };
    this.excelService.exportExcelAdminReport(excelData, 'Informe_firma_digital');
  }

  createPdf() {
    let doc = new jsPDF();
    let dataPdf: any[] = [];
    let rowFormat: any = [];
    doc.setProperties({
      title: 'Informe firma digital',
    });
    doc.text('Informe firma digital', 14, 45);
    doc.setFontSize(12);
    var img = new Image();
    img.src = 'assets/img/logo.PNG';
    doc.addImage(img, 'png', 3, 10, 80, 30);
    const filename = 'Informe_firma_digital_' + moment().locale('es').format('DDMMYYYY');

    this.dataSource.data.forEach((row) => {
      rowFormat = {
        request: row.dataWeb.strNumSol ? row.dataWeb.strNumSol : ' ',
        version: row.dataWeb.versionSignature ? row.dataWeb.versionSignature : ' ',
        nif: row.dataWeb.legalIdentity_id ? row.dataWeb.legalIdentity_id : ' ',
        logaltyDocResult: row.dataLogalty.document_result ? row.dataLogalty.document_result : ' ',
        statusFinalLogalty: row.dataLogalty.final_state ? row.dataLogalty.final_state : ' ',
        webDocResult: row.dataWeb.document_result ? row.dataWeb.document_result : ' ',
        statusFinalWeb: row.dataWeb.final_state ? row.dataWeb.final_state : ' ',
        statusWebPetition: row.dataWeb.strEstPeticion ? row.dataWeb.strEstPeticion : ' ',
        receptorHost: row.dataHost?.legalIdentity_id ? row.dataHost.legalIdentity_id : ' ',
        statusfinalHost: row.dataHost?.final_state ? row.dataHost.final_state : ' ',
        statusHostPetition: row.dataHost?.strEstPeticion ? row.dataHost.strEstPeticion : ' ',
      };

      const { ...data } = rowFormat;

      const dataPdfOrder = JSON.stringify(data, [
        'request',
        'version',
        'nif',
        'logaltyDocResult',
        'statusFinalLogalty',
        'webDocResult',
        'statusFinalWeb',
        'statusWebPetition',
        'receptorHost',
        'statusfinalHost',
        'statusHostPetition',
      ]);
      const ObjectDataPdf = JSON.parse(dataPdfOrder);
      dataPdf.push(ObjectDataPdf);
    });

    autoTable(doc, {
      startY: 55,
      margin: 2,
      head: this.head,
      headStyles: { fillColor: '#969696' },
      showHead: 'firstPage',
      body: dataPdf.map(Object.values),
    });

    var blob = doc.output('blob');
    FileSaver.saveAs(blob, filename);
    window.open(URL.createObjectURL(blob));
  }

  private showDialogError(error: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }
}
